import React from 'react';
import { Section } from './Section';
export function ProblemSection() {
  const pains = ['Esas charlas imaginarias y problemas del trabajo que solo aparecen cuando apoyás la cabeza en la almohada', 'Te despertás a las 3am y los pensamientos arrancan solos', "Ese primer pensamiento de derrota al sonar la alarma: 'cómo voy a sobrevivir a hoy'", 'Tensión en el cuerpo, mandíbula apretada, corazón acelerado al acostarse', 'Pensamientos en loop que no podés frenar', 'Anticipás problemas que todavía no pasaron', 'Al otro día estás irritable, sin energía, sin foco', 'La sensación de que ya te olvidaste lo que era despertarte con ganas y buen humor'];
  return <Section className="bg-bgHero py-20 px-4 sm:px-6 lg:px-8 relative" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        <h2 className="font-serif text-3xl md:text-4xl text-center text-headlineLight mb-12" data-id="element-234">
          "¿Te suena familiar esa escena a las 3:00 a.m.?"
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-16" data-id="element-235">
          {pains.map((pain, i) => <div key={i} className="bg-[rgba(45,27,78,0.4)] border-l-[3px] border-l-dangerSoft rounded-r-xl p-5 flex items-start gap-4" data-id="element-236">
              <span className="text-dangerIcon text-xl mt-0.5" data-id="element-237">❌</span>
              <p className="text-bodyOnDark text-sm md:text-base leading-relaxed" data-id="element-238">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="max-w-2xl mx-auto text-center" data-id="element-239">
          <p className="text-xl md:text-2xl font-serif italic text-accentText leading-relaxed" data-id="element-240">
            "No es falta de voluntad. Es que tu sistema nervioso está atrapado
            en un loop.
            <br data-id="element-241" />
            Este sistema es el interruptor que nadie te enseñó a usar."
          </p>
        </div>
      </div>
    </Section>;
}